import { DATASETS_PATH } from "const/routes";
import React, { FC } from "react";
import { Navigate, useParams } from "react-router";

const RedirectToDefault: FC = () => {
  const { projectId, encodedVersionId } = useParams();
  return <Navigate to={`${DATASETS_PATH}${projectId ? `/${projectId}` : ''}${encodedVersionId ? `/${encodedVersionId}` : ''}`} />;
};

export default RedirectToDefault;
